<template>
  <input
    :id="id"
    class="ds-input"
    :class="{ invalid }"
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :aria-invalid="invalid ? 'true' : 'false'"
    @input="$emit('input', $event.target.value)"
    @blur="$emit('blur', $event)"
  >
</template>

<script>
export default {
  name: 'DsInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    id: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.ds-input {
  @include ds-field;

  width: 100%;

  &::placeholder { color: $c-text-ter; }

  &:focus { @include ds-focus-ring; }

  @include ds-autofill-guard;

  &.invalid {
    border-color: $c-danger;
    background: $c-danger-light;

    &:focus { @include ds-focus-ring($c-danger); }

    // Without this the white cover above would paint over the invalid tint.
    @include ds-autofill-guard($c-danger-light, $c-danger);
  }

  &:disabled {
    background: $c-bg;
    color: $c-text-sec;
    cursor: not-allowed;

    @include ds-autofill-guard($c-bg, null);
  }
}
</style>
